(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-laundry-offer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cart-laundry-offer')) {
    customElements.define('cart-laundry-offer', class extends HTMLElement {
      async connectedCallback() {
        /* Put the code on the cart, so the −50 % shows in the cart and at checkout without a code field (DEV-283).
           Codes already on the cart (e.g. from a link) are kept; the code is only added when it is missing.
           At most twice per page, so a cart that refuses the code cannot loop. */
        /* DEV-581: where the offer shows, the liquid is not in the cart, so a LAUNDRY50 left from earlier cannot apply. Take only that code off; other codes stay. */
        if (this.hasAttribute('data-clean') && !this.lmBusy && !window.lmLaundryCodeCleaned) {
          window.lmLaundryCodeCleaned = true;
          try {
            const root = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
            const code = this.dataset.code.toUpperCase();
            const cart = await (await fetch(root + 'cart.js')).json();
            const list = cart.discount_codes || [];
            if (list.some((d) => d.code.toUpperCase() === code && !d.applicable)) {
              await fetch(root + 'cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ discount: list.filter((d) => d.code.toUpperCase() !== code).map((d) => d.code).join(',') })
              });
            }
          } catch (e) {}
          return;
        }
        if (!this.hasAttribute('data-apply') || this.lmBusy || (window.lmLaundryCodeTries || 0) >= 2) return;
        this.lmBusy = true;
        try {
          const root = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
          const code = this.dataset.code;
          const cart = await (await fetch(root + 'cart.js')).json();
          const codes = (cart.discount_codes || []).map((d) => d.code);
          if (codes.some((c) => c.toUpperCase() === code.toUpperCase())) return;
          window.lmLaundryCodeTries = (window.lmLaundryCodeTries || 0) + 1;
          const res = await fetch(root + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ discount: codes.concat(code).join(',') })
          });
          const updated = await res.json();
          const ok = (updated.discount_codes || []).some((d) => d.code.toUpperCase() === code.toUpperCase() && d.applicable);
          /* The liquid is in the cart, so show the new price right away. */
          if (ok && this.hidden) {
            if (/\/cart\/?$/.test(location.pathname)) location.reload();
            else document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          }
        } catch (e) {
        } finally {
          this.lmBusy = false;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-second-colour"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cart-second-colour')) {
    customElements.define('cart-second-colour', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const variants = this.querySelector('[data-variants]');
        const choices = [...variants.options].filter(option => option.value);
        const swatchBox = this.querySelector('.second-colour__swatches');
        const colourName = this.querySelector('[data-colour-name]');
        const size = this.querySelector('[data-size-picker]');
        const placeholder = size.options[0].text;
        const button = this.querySelector('[type="submit"]');
        const preview = this.querySelector('[data-preview]');
        const price = this.querySelector('[data-offer-price]');
        const unavailable = this.querySelector('[data-unavailable]');
        const totalLine = this.querySelector('[data-total-line]');
        const total = this.querySelector('span[data-total]');
        const source = this.querySelector('template[data-swatch-source]');
        const swatches = new Map();
        if (source) for (const span of source.content.querySelectorAll('[data-colour]')) swatches.set(span.dataset.colour, span.dataset.swatch);
        const initial = choices.find(option => option.value === this.dataset.defaultId) || choices[0];
        let colour = initial.dataset.colour;
        const update = () => {
          const match = choices.find(option => option.dataset.colour === colour && option.dataset.size === size.value);
          variants.value = match ? match.value : '';
          button.disabled = !match;
          price.textContent = match ? '\u00a0— ' + match.dataset.price : '';
          total.textContent = match ? match.dataset.total : '';
          totalLine.hidden = !match;
          const imageOption = match || choices.find(option => option.dataset.colour === colour);
          if (imageOption && imageOption.dataset.image) {
            preview.src = imageOption.dataset.image;
            preview.alt = colour;
            preview.hidden = false;
          }
        };
        const updateSizes = (preferred) => {
          size.replaceChildren(new Option(placeholder, ''));
          for (const option of choices.filter(option => option.dataset.colour === colour)) size.add(new Option(option.dataset.size, option.dataset.size));
          const available = [...size.options].some(option => option.value === preferred);
          size.value = available ? preferred : '';
          unavailable.textContent = !available && preferred ? unavailable.dataset.template.replace('[size]', preferred) : '';
          unavailable.hidden = available || !preferred;
          update();
        };
        const selectColour = (value, focus) => {
          colour = value;
          colourName.textContent = value;
          for (const swatch of swatchBox.children) {
            const checked = swatch.dataset.value === value;
            swatch.setAttribute('aria-checked', checked ? 'true' : 'false');
            swatch.tabIndex = checked ? 0 : -1;
            if (checked && focus) swatch.focus();
          }
          updateSizes(size.value || this.dataset.size);
        };
        const colours = [...new Set(choices.map(option => option.dataset.colour))];
        for (const value of colours) {
          const swatch = document.createElement('button');
          swatch.type = 'button';
          swatch.className = 'second-colour__swatch';
          swatch.setAttribute('role', 'radio');
          swatch.setAttribute('aria-label', value);
          swatch.title = value;
          swatch.dataset.value = value;
          const background = swatches.get(value);
          const image = choices.find(option => option.dataset.colour === value).dataset.image;
          if (background) swatch.style.setProperty('--swatch-background', background);
          else if (image) swatch.style.setProperty('--swatch-background', 'url(' + image + ')');
          swatch.addEventListener('click', () => selectColour(value));
          swatchBox.append(swatch);
        }
        swatchBox.addEventListener('keydown', (event) => {
          const step = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[event.key];
          if (!step) return;
          event.preventDefault();
          const index = (colours.indexOf(colour) + step + colours.length) % colours.length;
          selectColour(colours[index], true);
        });
        size.addEventListener('change', () => {
          unavailable.hidden = true;
          update();
        });
        this.querySelector('.second-colour__fallback').hidden = true;
        this.querySelector('.second-colour__pickers').hidden = false;
        colourName.textContent = colour;
        for (const swatch of swatchBox.children) {
          const checked = swatch.dataset.value === colour;
          swatch.setAttribute('aria-checked', checked ? 'true' : 'false');
          swatch.tabIndex = checked ? 0 : -1;
        }
        updateSizes(this.dataset.size);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
